// File: not-found.component.ts
// Author: Joseph M Diaz
// Date: 4/24/2017
// Desc: Component for the 404 page.
// Other Contributors:

import { Component } from '@angular/core';

@Component({
    templateUrl: './not-found.template.html'
})
export class NotFoundComponent { }